"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadingIndicator = void 0;
var React = __importStar(require("react"));
var react_1 = require("@chakra-ui/react");
var MediaContext_1 = require("../../MediaContext");
function LoadingIndicator() {
    var _js = (0, MediaContext_1.useMediaContext)()._js;
    return (React.createElement(react_1.Flex, { direction: "column", justifyContent: "center", align: "center", flex: 1 },
        React.createElement(react_1.Heading, { mb: 4, textAlign: "center", fontSize: "1.5em" }, _js('Loading image editor')),
        React.createElement(react_1.Progress, { isIndeterminate: true, isAnimated: true, w: "70%" })));
}
exports.LoadingIndicator = LoadingIndicator;
